import * as actionTypes from "./actionTypes";

// Shop
export const mallLoadShopDetails = id => {
  return {
    type: actionTypes.MALL_LOAD_SHOP_DETAIL,
    id
  };
};

export const mallLoadShopDetailsSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_SHOP_DETAIL_SUCCESS,
    data
  };
};

export const mallLoadShopDetailsFail = () => {
  return {
    type: actionTypes.MALL_LOAD_SHOP_DETAIL_FAIL
  };
};
// END Shop
